import React from 'react'
import { Box, Typography } from '@mui/material'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import { AdvancedContentCompletion, AdvancedTrackSummary } from '../api/types'
import { groupCompletionsByTrack } from '../api/selectors'
import { advancedColors } from '../theme'
import { relativeDay } from '../format'
import EmptyState from './EmptyState'

const CompletionRow = ({ item }: { item: AdvancedContentCompletion }) => (
  <Box sx={{ display: 'flex', gap: 1.5, py: 1.25 }}>
    <CheckCircleRoundedIcon sx={{ fontSize: 20, mt: 0.25, color: advancedColors.green, flexShrink: 0 }} />
    <Box sx={{ flex: 1, minWidth: 0, display: 'flex', justifyContent: 'space-between', gap: 1.5 }}>
      <Typography variant="h6" sx={{ color: advancedColors.ink }}>
        {item.title}
      </Typography>
      <Typography variant="subtitle2" sx={{ flexShrink: 0, color: advancedColors.ink }}>
        {relativeDay(item.completedAt)}
      </Typography>
    </Box>
  </Box>
)

type Props = {
  tracks: AdvancedTrackSummary[]
  completions: AdvancedContentCompletion[]
}

const ContentProgressList = ({ tracks, completions }: Props) => {
  if (completions.length === 0) {
    return <EmptyState title="Nothing completed yet" description="Lessons appear here once the patient finishes one." />
  }

  const groups = groupCompletionsByTrack(tracks, completions)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {groups.map((group) => {
        if (group.completions.length === 0) {
          return null
        }

        return (
          <Box key={group.trackKey}>
            <Typography variant="overline">{group.trackKey}</Typography>
            <Box sx={{ mt: 0.5, '& > * + *': { borderTop: `1px solid ${advancedColors.line}` } }}>
              {group.completions.map((item) => (
                <CompletionRow key={item.completionId} item={item} />
              ))}
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

export default ContentProgressList
